<template>
  <div id="cta-section">
    <div class="shaddow-cont"></div>
    <div class="cta-content">
      <div class="cta">
        <p>Do you have a project idea?</p>
        <h2>Let's Work Together!</h2>

        <GetQuote />
      </div>
    </div>
  </div>
</template>

<script>
import GetQuote from "./Modals/GetQuote";
export default {
  components: {
    GetQuote,
  },
};
</script>

<style lang="scss">
#cta-section {
  position: relative;
  .shaddow-cont {
    width: 100%;
    box-shadow: 0 6px 4px -4px #131212;
    position: absolute;
    top: -9px;
    height: 10px;
    background: $white;
    z-index: 5;
  }
  .cta-content {
    background-image: url(../assets/images/gump-run.jpg);
    background-position: 23%;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    padding: 160px 1rem;
    position: relative;
    z-index: 3;
    box-shadow: 0 6px 11px 0 rgb(0 0 0 / 60%);

    .cta {
      text-align: center;
      p {
        color: $white;
        text-shadow: #000 0 2px 4px;
        font-size: 1.5rem;
      }
      h2 {
        color: $mcf-blue;
        text-shadow: #000 0 3px 3px;
        font-size: 3rem;
        line-height: 1.2;
        font-family: "Montserrat", sans-serif;
      }
      .cta-sec-btn {
        background-color: $mcf-blue;
        color: $white;
        font-weight: 600;
        margin-top: 2rem;
      }
    }
  }
}
</style>